import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import * as S from './SrcDestPickerStyles'
import HobHeader from '../HobHeader/HobHeader';
import { cabsAutoSuggest, getPlaceDetails } from '../../../redux/thunks';
import { UPDATE_HOB_DESTINATION_LOCATION, UPDATE_HOB_SOURCE_LOCATION } from '../../../redux/action-types';
import { pushCtaOmniEvents } from '../../../../../config/omni';
import { CABS_HOB_LANDING_ROUTE, HOB_LANDING_PAGE, MOB_CABS_HOB_LANDING, SELECTED_FOR_FARE_CHECK } from '../../../../../utils/util-constants';
import { CTA_TYPE } from '../../../../../utils/omni-utils';

interface SrcDestPickerProps {
  isPickup: boolean;
  locationName?: string;
  onBackClick: () => void;
}

const SrcDestPicker = (props: SrcDestPickerProps) => {
  const dispatch = useDispatch()
  const [autoCompleteResults, setAutoCompleteResults] = useState([]);
  const [locationName, setlocationName] = useState(props?.locationName || '');
  const autoFocusRef = useRef();

  const updateSuggestResults = async (val: string) => {
    setlocationName(val);
    setAutoCompleteResults(await cabsAutoSuggest({input: val }));
  };

  useEffect(() => {
    const setInitialAutoCompleteResults = async (input: string) => {
      let response = await cabsAutoSuggest({input});
      setAutoCompleteResults(response);
    }
    if (props?.locationName?.length > 0) {
      setInitialAutoCompleteResults(props?.locationName);
    }
  }, []);

  const onItemClicked = async (item: any) => {
    pushCtaOmniEvents(`${MOB_CABS_HOB_LANDING}_${item?.mainText}_${SELECTED_FOR_FARE_CHECK}`, CTA_TYPE.BUTTON, HOB_LANDING_PAGE, CABS_HOB_LANDING_ROUTE)

    let placeDetails = await getPlaceDetails(item?.placeId) || {};

    if (props?.isPickup) {
      dispatch({
        type: UPDATE_HOB_SOURCE_LOCATION,
        sourceLocation: placeDetails
      })
    } else {
      dispatch({
        type: UPDATE_HOB_DESTINATION_LOCATION,
        destinationLocation: placeDetails
      })
    }
    props?.onBackClick();
  };

  const onClear = () => {
    setlocationName('');
    setAutoCompleteResults([]);
    autoFocusRef?.current?.focus();
  };

  return (
    <S.Container>
      <S.DestinationInputView>
        <HobHeader
          title={props?.isPickup ? 'Enter Source' : 'Enter Destination'}
          onIconClick={props?.onBackClick}
        />
        <S.Label>{props?.isPickup ? 'FROM' : 'TO'}</S.Label>
        <S.InputContainer>
          <S.Width90>
            <input
              type="text"
              className={"destinationInput"}
              placeholder=""
              value={locationName}
              onChange={(e) => updateSuggestResults(e.target.value)}
              autoFocus={true}
              ref={autoFocusRef}
            />
          </S.Width90>
          <div style={{ marginLeft: 'auto' }}>
            <S.ClearButton onClick={onClear}>CLEAR</S.ClearButton>
          </div>
        </S.InputContainer>
        <S.BottomLine></S.BottomLine>
      </S.DestinationInputView>
      <S.Separator></S.Separator>
      {autoCompleteResults && autoCompleteResults?.length > 0 && locationName?.length > 0 && (
        <div>
          {autoCompleteResults.map((item) => (
            <S.CityListItem onClick={() => onItemClicked(item)}>
              <S.CityListItemPrimaryTextContainer>
                <S.CityListItemPrimaryText>
                  {item?.matches?.map((match) => {
                    if (match?.matched) {
                      return (
                        <S.CityListItemMatchedPrimaryText>
                          {match?.text}
                        </S.CityListItemMatchedPrimaryText>
                      );
                    } else {
                      return (
                        <S.CityListItemPrimaryText key={match.text}>
                          {match?.text}
                        </S.CityListItemPrimaryText>
                      );
                    }
                  })}
                </S.CityListItemPrimaryText>
              </S.CityListItemPrimaryTextContainer>
              <S.CityListItemSecondaryText>{item?.secondaryText}</S.CityListItemSecondaryText>
            </S.CityListItem>
          ))}
        </div>
      )}
    </S.Container>
  );
};

export default SrcDestPicker;

